export default "__VITE_ASSET__BlHAa_yQ__"